import { SET_CURRENT_PAGE } from "../types";

const adminNavReducer = (state, action) => {
  switch (action.type) {
    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };

    default:
      return state;
  }
};

export default adminNavReducer;
